<template>
  <b-navbar-nav>
    <b-nav-form
      on-submit="return false;"
      class="navbar-search"
      autocomplete="off"
    >
      <label for="navbar-search-control">
        <svg class="icon icon-icon-search">
          <use xlink:href="#icon-icon-search" />
        </svg>
      </label>
      <form @submit.prevent>
        <b-form-input
          id="navbar-search-control"
          ref="searchField"
          :value="search.value"
          :placeholder="$t('searchbar.search-item')"
          autocomplete="off"
          @input="$emit('input', $event)"
          @keyup.enter="$emit('enter')"
          @focus="showSearch"
        />
      </form>

      <b-dropdown
        ref="barcodeDropdown"
        size="lg"
        variant="link"
        toggle-class="text-decoration-none navbar-search__barcode-btn"
        no-caret
      >
        <template v-slot:button-content>
          <svg class="icon icon-icon-code">
            <use xlink:href="#icon-icon-code" />
          </svg>
        </template>
        <b-dropdown-text>
          <NumPad
            :search-value="search.value"
            @confirm-action="$emit('barcode-confirm', $event)"
            @barcode-input-change="$emit('barcode-input-change', $event)"
            @hide-barcode-numpad="hideBarcodeNumpad"
          />
        </b-dropdown-text>
      </b-dropdown>
      <div
        v-if="search.visible"
        ref="searchResultsContainer"
        class="navbar-search-res show"
        @scroll="onSearchScroll"
      >
        <div
          v-if="search.canScrollUp"
          class="search-scroll-indicator search-scroll-up"
        >
          <span>↑ Scroll or swipe up for more</span>
        </div>
        <ul class="list-unstyled">
          <li
            v-for="foundProduct in search.results"
            :key="foundProduct.id"
            @click="$emit('select-product', foundProduct)"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <span
                  v-if="!foundProduct.image"
                  class="search-color-tag"
                  :style="{ background: transformColor[foundProduct.color.toLowerCase()] ? transformColor[foundProduct.color.toLowerCase()] : foundProduct.color }"
                />
                <img
                  v-else
                  :src="foundProduct.image"
                  class="search-color-tag"
                  style="object-fit: cover;"
                >
                <span>{{ getDisplayName(foundProduct) }}</span>
              </div>
              <div>
                <span class="search-price-pill">{{ currency }} {{ foundProduct.price.toFixed(2) }}</span>
              </div>
            </div>
          </li>
        </ul>
        <div
          v-if="search.canScrollDown"
          class="search-scroll-indicator search-scroll-down"
        >
          <span>↓ Scroll or swipe down for more</span>
        </div>
      </div>
    </b-nav-form>
    <div
      v-if="search.visible && !($refs.barcodeDropdown && $refs.barcodeDropdown.visible)"
      class="keyboard-mask"
      @click="$emit('hide')"
    />
  </b-navbar-nav>
</template>

<script>
import NumPad from "@/components/Order/Search/NumPad";

export default {
  name: "OrderSearchBar",
  components: {
    NumPad,
  },
  props: {
    // Live search state object owned by the parent view (value/visible/results/
    // canScrollUp/canScrollDown). The scroll/visibility-only fields are mutated
    // in place here (pure UI); all business actions are emitted up.
    search: {
      type: Object,
      default: () => ({
        value: "",
        visible: false,
        results: [],
        canScrollUp: false,
        canScrollDown: false,
      }),
    },
    currency: {
      type: String,
      default: "",
    },
    transformColor: {
      type: Object,
      default: () => ({}),
    },
    getDisplayName: {
      type: Function,
      default: (product) => (product ? product.name : ""),
    },
  },
  watch: {
    // Mirrors the original doSearch() behaviour, which re-ran the scroll-state
    // check after refreshing the results list.
    "search.results"() {
      this.$nextTick(() => this.checkSearchScroll());
    },
  },
  methods: {
    // Exposed so the parent's onKeyPress can keep focusing the search field.
    focusSearchField() {
      try {
        this.$refs.searchField.focus();
      } catch (e) {
        //
      }
    },
    showSearch() {
      const barCodeNumPad = this.$refs.barcodeDropdown;
      if (!this.search.visible && !barCodeNumPad.visible) {
        this.search.visible = true;
      }
    },
    onSearchScroll() {
      this.$nextTick(() => {
        const container = this.$refs.searchResultsContainer;
        if (container) {
          const scrollTop = container.scrollTop;
          const scrollHeight = container.scrollHeight;
          const clientHeight = container.clientHeight;

          this.search.canScrollUp = scrollTop > 10;
          this.search.canScrollDown = scrollTop + clientHeight < scrollHeight - 10;
        }
      });
    },
    checkSearchScroll() {
      this.$nextTick(() => {
        const container = this.$refs.searchResultsContainer;
        if (container) {
          const hasScroll = container.scrollHeight > container.clientHeight;
          this.search.canScrollDown = hasScroll;
          this.search.canScrollUp = false;
        }
      });
    },
    // Exposed so the parent (resetSearch) can keep collapsing the numpad.
    hideBarcodeNumpad() {
      this.$refs.barcodeDropdown ? this.$refs.barcodeDropdown.hide(true) : "";
    },
  },
};
</script>
